import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-157" data-mp="1o33tsfx1zqh8">
      <div className="mx-auto max-w-xl rounded-2xl border border-gold-500/30 bg-navy-900 p-5 text-center sm:p-8" data-id="element-158" data-mp="223ofbjucs0ef">
        <ShieldCheckIcon className="mx-auto h-14 w-14 text-gold-400" aria-hidden="true" strokeWidth={1.5} data-id="element-159" data-mp="1x5mw8ywxg12y" />
        <h2 className="mt-4 font-display text-2xl font-700 uppercase leading-tight text-white sm:text-3xl" data-id="element-160" data-mp="14fo1qnzyrbqw">
          7-Day 100% risk-free guarantee
        </h2>
        <p className="mt-2 font-display text-lg font-600 uppercase tracking-wide text-gold-400" data-id="element-161" data-mp="1j652e54rxxmq">
          Try DVO Master Protocol™ for 7 days
        </p>

        <p className="mt-4 text-sm leading-relaxed text-slate-300" data-id="element-162" data-mp="qnpz8w0rce3p">
          Take the system inside your practice and see whether it gives you more structure and
          clarity when organizing your DVO assessments. If you decide it’s not right for you, you
          can request a refund within the applicable 7-day guarantee period.
        </p>

        <div className="mt-6 space-y-1 font-display text-base font-700 uppercase tracking-wide text-white" data-id="element-163" data-mp="twrwstgctuum">
          <p data-id="element-164" data-mp="yrfmgvn3gvas">No long-term commitment.</p>
          <p data-id="element-165" data-mp="12rfyyaqmuwf7">No subscription.</p>
          <p data-id="element-166" data-mp="12pmv137emqaw">Just 7 days to review the system.</p>
        </div>

        <div className="mt-7" data-id="element-167" data-mp="61716ux9hurz">
          <CTAButton label="Yes, I want to try DVO Master Protocol™" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-168" data-mp="61yw03j1boh7" />
        </div>
      </div>
    </section>;
}